import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "utils/dayjsPlugins";
import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "theme/theme";
import "./index.sass";
import App from "./App";
import { Auth0Provider } from "./react-auth0-spa";
import axios from "axios";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "authentication/msal/msal-config";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import { WebSocketProvider } from "utils/WebSockets/WebSocketProvider";
import "./utils/RUM/awsRUM.js";

const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

const onRedirectCallback = (appState) => {
  window.location.href = 
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname;
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// 👇 CRITICAL: Initialize MSAL before rendering
msalInstance
  .initialize()
  .then(() => {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <WebSocketProvider>
            <Auth0Provider
              domain={AUTH0_DOMAIN}
              client_id={AUTH0_CLIENT_ID}
              redirect_uri={window.location.origin}
              scope="openid read:appointments"
              audience={AUTH0_AUDIENCE}
              cacheLocation="localstorage"
              useRefreshTokens={true}
              useRefreshTokensFallback={true}
              onRedirectCallback={onRedirectCallback}
              httpClient={axios}
            >
              <MsalProvider instance={msalInstance}>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </MsalProvider>
            </Auth0Provider>
          </WebSocketProvider>
        </ThemeProvider>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error("MSAL initialization failed:", error);
    // Show a user-friendly error instead of blank screen
    root.render(
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Authentication Error</h2>
        <p>Failed to initialize authentication. Please refresh the page.</p>
        <button onClick={() => window.location.reload()}>Refresh</button>
      </div>
    );
  });

serviceWorker.unregister();